import React, { Suspense, Fragment } from 'react'
// import { Navbar } from '../navbar'
// import { AppFooter } from '../app-footer'
import './styles.scss'

const withSuspense = Component => {
  return props => (
    <Suspense
      fallback={
        <Fragment>
          <div>...Loading</div>
        </Fragment>
      }
    >
      <Component {...props} />
    </Suspense>
  )
}

export default withSuspense
